import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, FormGroup, Label, Row } from 'reactstrap';
import ButtonSection from '../ProjectCreate/ButtonSection';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';

const CreateNewTicketOfferForm = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
        offerId: 0,
        offerName: "",
        adultBuy: 0,
        childBuy: 0,
        totalFree: 0,
        freeType: "Adult",
        totalCount: 0,
        isOfferActive: true
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const payload = {
        offerId: 0,
        offerName: formData.offerName,
        adultBuy: formData.adultBuy,
        childBuy: formData.childBuy,
        totalFree: formData.totalFree,
        freeType: formData.freeType,
        totalCount: formData.totalCount,
        isOfferActive: true
    };
    alert('offername'+payload.offerName+"free"+payload.totalFree+"total"+payload.totalCount);
    if(!payload.offerName || payload.totalFree < 0 || payload.totalCount < 0) {
        Swal.fire({
            icon: 'warning',
            title: 'Validation Error',
            text: 'Please fill all the required fields.',
        });
        return; // Stop submission if validation fails
    }
    if (payload.offerName.trim() === "") {
        Swal.fire("Error!", "Offer name cannot be empty.", "error");
        return;
    }
    if (isNaN(Number(payload.totalFree)) || Number(payload.totalFree) <= 0) {
        Swal.fire("Error!", "Please enter a valid total free ticket.", "error");
        return;
    }
    if (isNaN(Number(payload.totalCount)) || Number(payload.totalCount) <= 0) {
        Swal.fire("Error!", "Please enter a valid original price.", "error");
        return;
    }


    try {
        const response = await api.post('/api/OfferPlan/AddTicketOfferPlan', payload, {
          headers: {
            'Content-Type': 'application/json',
          }
        });
    
        if (response.status === 200 || response.status === 201) {
          Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Ticket Offer created successfully.',
            }).then(() => {
            navigate(`${process.env.PUBLIC_URL}/ticket/all_ticket_offer`);
          });
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Unexpected Response',
            text: 'Please try again later.',
          });
        }
    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Submission Failed',
            text: 'Something went wrong while creating the ticket offer.',
    });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="theme-form">
      <Row>
        <Col sm="4">
          <FormGroup>
            <Label>Offer Name</Label>
            <input
              name="offerName"
              type="text"
              className="form-control"
              placeholder="Enter offer name..."
              value={formData.offerName}
              required={true}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Offer For</Label>
            <select name='freeType' className='form-control' required={true} onChange={handleChange}>
                <option value=" ">Select Offer For</option>
                <option value="Adult">Adult</option>
                <option value="Child">Child</option>
            </select>
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>No. Of Adults</Label>
            <input
              name="adultBuy"
              type="number"
              className="form-control"
              placeholder="Enter number of adults..."
              value={formData.adultBuy}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>No. Of Child</Label>
            <input
              name="childBuy"
              type="number"
              className="form-control"
              placeholder="Enter number of childrens..."
              value={formData.childBuy}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Free Ticket</Label>
            <input
              name="totalFree"
              type="number"
              className="form-control"
              placeholder="Enter number of free ticket..."
              value={formData.totalFree}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
        <Col sm="4">
          <FormGroup>
            <Label>Total Ticket</Label>
            <input
              name="totalCount"
              type="number"
              className="form-control"
              placeholder="Enter number of total tickets..."
              value={formData.totalCount}
              onChange={handleChange}
            />
          </FormGroup>
        </Col>
      </Row>
      <ButtonSection cancel_url={`/ticket/all_ticket_offer`} />
    </form>
  );
};

export default CreateNewTicketOfferForm;